import React from 'react';
import UpdateCard from '../nba/UpdateCard';
import ProductCard from '../nba/ProductCard';
import QuickLinksTile from './QuickLinksTile';
import { shouldShowQuickLinks } from './HomepageTilesUtils';

const homepageSMETiles = ({ updates, products, invokeModal }) => [
  updates && (
    <UpdateCard
      data={updates}
      action={invokeModal}
      key={'homepageSMETiles_UpdateCard'}
    />
  ),
  products && (
    <ProductCard
      data={products}
      action={invokeModal}
      key={'homepageSMETiles_ProductCard'}
    />
  ),
  shouldShowQuickLinks() && (
    <QuickLinksTile key={'homepageSMETiles_QuickLinksTile'} />
  ),
];

export default homepageSMETiles;
